import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AppMain from './AppMain';
import AppPrinting from './AppPrinting';
import GetQuote from './GetQuote';
import Blog from './Blog';
import Post2 from './Post2';
import Post3 from './Post3';
import Post4 from './Post4';
import Policy from './Policy';
import TrainingGraphics from './TrainingGraphics';
import Academy from './Academy';
import ThankYou from './ThankYou';
import ReactGA from 'react-ga';
import { useEffect } from 'react';
import { MobileAppTraining } from './components/MobileAppTraining';
import { SketchwareTheoryGuide } from './components/SketchwareTheoryGuide';
import { GraphicsTrainingAdvance } from './components/GraphicsTrainingAdvance';
import { FullSTackTraining } from './components/FullSTackTraining';
import { ThankYouMAPurchase } from './components/ThankYouMAPurchase';
import Payment from './Payment';
//import ReactPixel from 'react-facebook-pixel';


function App() {
  const TRACKING_ID = 'UA-262390893-1';
  ReactGA.initialize(TRACKING_ID);
  
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <>
    <Router>
    <div className="App">
      
      <Routes>
        <Route path='/' element={<AppMain />} />
        <Route path='/printing' element={<AppPrinting />} />
        <Route path='/get-quote' element={<GetQuote />} />
        <Route path='/blog' element={<Blog />} />
        <Route path='/five-advantages-of-using-a-professional-designer-for-your-business' element={<Post2 /> }/>
        <Route path='/how-to-choose-the-right-domain-name-for-your-business' element={<Post3 />}/>
        <Route path='/core-branding-proposal-tips' element={<Post4 />}/>
        <Route path='/graphic-training-portal' element={<TrainingGraphics />}/>
        <Route path='/academy' element={<Academy />}/>
        <Route path='/payment' element={<Payment />}/>
        <Route path='/academy/app-development' element={<MobileAppTraining />} />
        <Route path='/academy/web-development' element={<FullSTackTraining />} />
        <Route path='/academy/sketchware-theory-guide' element={<SketchwareTheoryGuide />} />
        <Route path='/academy/graphic-design' element={<GraphicsTrainingAdvance />} />
        <Route path='/purchase-successful' element={<ThankYou />}/>
        <Route path='/purchase-successful2' element={<ThankYouMAPurchase />}/>
        <Route path='/privacy-policy' element={<Policy />}/>
      </Routes>
    </div>
    </Router>
    </>
  );
}

export default App;
